'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _jsonp = require('jsonp');

var _jsonp2 = _interopRequireDefault(_jsonp);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function (ctx) {
  return new Promise(function (resolve, reject) {
    var params = ctx.req.params || {};
    var url = params.url;
    // 处理 jsonp 请求
    if (params.type === 'jsonp') {
      var jsonpUrl = url;
      if (params.data && _typeof(params.data) === 'object') {
        jsonpUrl = (0, _utils.urlQueryJoin)(url, params.data);
      }
      (0, _jsonp2.default)(jsonpUrl, {
        param: params.jsonpCallback,
        name: params.jsonpCallbackName,
        timeout: params.timeout || 5000
      }, function (err, data) {
        if (err) {
          err.ctx = ctx;
          reject(err);
        } else {
          ctx.res.data = data;
          resolve(ctx);
        }
      });
    } else {
      var axiosParams = (0, _utils.toAxiosParams)(params);
      (0, _axios2.default)(axiosParams).then(function (resp) {
        ctx.res.data = resp.data || {};
        ctx.res.headers = resp.headers || {};
        ctx.res.xhr = resp.request;

        resolve(ctx);
      }).catch(function (err) {
        // for error info extracting
        err.ctx = ctx;
        reject(err);
      });
    }
  });
};